import React from 'react';
import { useDevice } from '../../contexts/DeviceContext';
import { ActionsList } from '../ActionsList';

const ActionsPage: React.FC = () => {
  const { selectedDevice } = useDevice();

  if (!selectedDevice) return null;

  return <ActionsList deviceId={selectedDevice.id} deviceName={selectedDevice.name} />;
};

export default ActionsPage;
